




AFRAME.registerComponent('perimeter-fence', {

	schema: {
	  radius: {type: 'number', default: 10},
	  posts: {type: 'number', default: 50}
	},
  
	init() {
	  for (ii = 0; ii < this.data.posts; ii++) {
  
		  const branch = document.createElement('a-entity');
		  branch.setAttribute("mixin", "branch");
		  branch.setAttribute('scale', "0.3 0.3 0.3")
		  branch.setAttribute("cylindrical-position",
							  `height:0.4;
							   radius:${this.data.radius};
							   angle:${ii * 360 / this.data.posts};
							   `);
		  branch.setAttribute("ammo-shape", "type:hull");
		  this.el.appendChild(branch);
	  }
	}
  });



AFRAME.registerComponent('letters-block', {

	schema: {
	  letters: {type: 'string', default: "ABCDEF"},
	  color: {type: 'color', default: 'red'},
	  letterColor: {type: 'color', default: 'white'}
	},
  
	init() {
  
	  const dim = 0.3;
  
	  const block = document.createElement('a-box');
	  block.setAttribute('height', dim);
	  block.setAttribute('width', dim);
	  block.setAttribute('depth', dim);
	  block.setAttribute('movement', "type:grabbable; stickiness:stickable; initialState:dynamic");
	  block.setAttribute("ammo-shape", "type:box");
	  block.setAttribute("rotation", `0 ${30 * (Math.random() - 0.5)} 0`);
	  block.setAttribute("color", this.data.color);
	  this.el.appendChild(block);
  
	  const positions = [
		`0 0 ${dim/2}`,
		`0 0 ${-dim/2}`,
		`0 ${dim/2} 0`,
		`0 ${-dim/2} 0`,
		`${dim/2} 0 0`,
		`${-dim/2} 0 0`,
	  ]
  
	  const rotations = [
		"0 0 0",
		"0 -180 0",
		"-90 0 0",
		"90 0 0",
		"0 90 0",
		"0 -90 0"
	  ]
  
	  for (ii = 0; ii < 6; ii++) {
		  const text = document.createElement('a-text');
		  text.setAttribute('value', this.data.letters[ii]);
		  text.setAttribute('wrap-count', '2');
		  text.setAttribute('color', this.data.letterColor);
		  text.setAttribute('width', '0.3');
		  text.setAttribute('align', 'center');
		  text.setAttribute('position', positions[ii]);
		  text.setAttribute('rotation', rotations[ii]);
		  block.appendChild(text);
	  }
	}
  });


// 3D Text
!function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t){var o=AFRAME.utils.debug,n=o("aframe-text-component:error"),r=new THREE.FontLoader;AFRAME.registerComponent("text-geometry",{schema:{bevelEnabled:{default:!1},bevelSize:{default:8,min:0},bevelThickness:{default:12,min:0},curveSegments:{default:12,min:0},font:{type:"asset",default:"https://rawgit.com/ngokevin/kframe/master/components/text-geometry/lib/helvetiker_regular.typeface.json"},height:{default:.05,min:0},size:{default:.5,min:0},style:{default:"normal",oneOf:["normal","italics"]},weight:{default:"normal",oneOf:["normal","bold"]},value:{default:""}},update:function(e){var t=this.data,o=this.el,a=o.getOrCreateObject3D("mesh",THREE.Mesh);t.font.constructor===String?r.load(t.font,function(e){var o=AFRAME.utils.clone(t);o.font=e,a.geometry=new THREE.TextGeometry(t.value,o)}):t.font.constructor===Object?a.geometry=new THREE.TextGeometry(t.value,t):n("Must provide `font` (typeface.json) or `fontPath` (string) to text component.")}})}]);




AFRAME.registerShader('threeColorGradientShader', {
    schema: {
        topColor: {type: 'color', default: '1 0 0', is: 'uniform'},
        middleColor: {type: 'color', default: '0 1 0', is: 'uniform'},
        bottomColor: {type: 'color', default: '0 0 1', is: 'uniform'}
    },

    vertexShader: [
        'varying vec3 vWorldPosition;',
        'void main() {',
        ' vec4 worldPosition = modelMatrix * vec4( position, 1.0 );',
        ' vWorldPosition = worldPosition.xyz;',
        ' gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0 );',
        '}'
    ].join('\n'),

    fragmentShader: [
        'uniform vec3 bottomColor;',
        'uniform vec3 middleColor;',
        'uniform vec3 topColor;',
        'uniform float offset;',
        'varying vec3 vWorldPosition;',
        'void main() {',
        ' float h = normalize( vWorldPosition ).y;',
        ' if (h>0.0) {',
        '   gl_FragColor = vec4( mix( middleColor, topColor, max( pow( max(h, 0.0 ), 0.8 ), 0.0 ) ), 1.0 );',
        ' } else {',
        '   gl_FragColor = vec4( mix( middleColor, bottomColor, max( pow( max(-h, 0.0 ), 0.8 ), 0.0 ) ), 1.0 );',
        ' }',
        '}'
    ].join('\n')
});

// I can use this to abstract the movement thing
AFRAME.registerComponent('move-down', {
	init: function() {
		this.initialY = this.el.object3D.position.y;
	},
	tick: function (time, timeDelta) {
		this.el.object3D.position.y -= Math.min(timeDelta/500, 1);
		this.el.emit("object3DUpdated");
	}
});

AFRAME.registerComponent('move-rand', {
	init: function() {
		this.initialZ = this.el.object3D.position.z;
		this.initialX = this.el.object3D.position.x;

	},
	tick: function (time, timeDelta) {
		// Move object randomly in x and z dimensions
		if (Math.random() > 0.5) {
		this.el.object3D.position.z -= Math.min(timeDelta/500, 1);
		} else {
		this.el.object3D.position.x -= Math.min(timeDelta/500, 1);
		}
		if(Math.random() > 0.5) {
		this.el.object3D.position.z += Math.min(timeDelta/500, 1);
		} else {
		this.el.object3D.position.x += Math.min(timeDelta/500, 1);
		}
		this.el.emit("object3DUpdated");
	}
});


AFRAME.registerComponent('move-forward', {
	init: function() {
		this.initialZ = this.el.object3D.position.z;
		this.initialX = this.el.object3D.position.x;

	},
	tick: function (time, timeDelta) {

		this.el.object3D.translateZ(0.01)
		// Rotate object slowly around Z axis
		this.el.object3D.rotation.y -= 0.001;


		this.el.emit("object3DUpdated");
	}
});


AFRAME.registerComponent('jiggle', {
	init: function() {
		this.initialZ = this.el.object3D.rotation.z;
		this.initialX = this.el.object3D.rotation.x;

	},
	tick: function (time, timeDelta) {
		// Move object randomly in x and z dimensions
		if (Math.random() > 0.5) {
		this.el.object3D.rotation.z -= Math.min(timeDelta/500, 1);
		} else {
		this.el.object3D.rotation.x -= Math.min(timeDelta/500, 1);
		}
		if(Math.random() > 0.5) {
		this.el.object3D.rotation.z += Math.min(timeDelta/500, 1);
		} else {
		this.el.object3D.rotation.x += Math.min(timeDelta/500, 1);
		}
		this.el.emit("object3DUpdated");
	}
});

let interval
AFRAME.registerComponent("touch", {
    init: function() {
		var player = document.querySelector("a-camera")
		window.addEventListener("touchstart", (e) => {
		e.preventDefault()
		interval = setInterval(() => {
			var angle = player.getAttribute("rotation")
			let theta = (angle.x * Math.PI / 180) + Math.PI / 2 
			let fi = angle.y * Math.PI / 180
			let r = 0.02
			let z = Math.sin(theta) * Math.cos(fi) * r
			let x = Math.sin(theta) * Math.sin(fi) * r
			let y = Math.cos(theta) * r
			var pos = player.getAttribute("position")
			pos.x -= x;
			pos.y -= y;
			pos.z -= z;
			player.setAttribute("position", pos);
		}, 5);
		})
		window.addEventListener("touchend", (e) => {
			clearInterval(interval)
		})
		// When window visibility changes, clear interval
		window.addEventListener("visibilitychange", function() {
			clearInterval(interval)
		})
	}
})



let snow_particleSystem, snow_particleCount = 10000, snow_points = [], snow_geometry;
AFRAME.registerComponent('snow', {
	schema: {
		event: {type: 'string', default: ''},
		message: {type: 'string', default: 'Hello, World!'}
	},
	init: function () {
		var scene = this.el.sceneEl.object3D
		let loader = new THREE.TextureLoader();
		loader.crossOrigin = '';
		let pMaterial = new THREE.PointsMaterial({
			color: 0xFFFFFF,
			size: 1.5,
			map: loader.load("https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/textures/sprites/snowflake2.png"),
			blending: THREE.AdditiveBlending,
			depthTest: false,
			transparent: true
		});
		snow_geometry = new THREE.BufferGeometry()
		for (var i = 0; i < snow_particleCount; i++) {
			var pX = Math.random()*500 - 250,
				pY = Math.random()*500 - 250,
				pZ = Math.random()*500 - 250,
				particle = new THREE.Vector3(pX, pY, pZ);
			particle.velocity = {};
			particle.velocity.y = 0;
			snow_points.push(particle);
		}
		snow_geometry.setFromPoints(snow_points)
		snow_geometry.computeVertexNormals()
		snow_geometry.verticesNeedUpdate = true;
		snow_particleSystem = new THREE.Points(snow_geometry, pMaterial);
		scene.add(snow_particleSystem);
  },
  tick: function(time, timeDelta) {
	var pCount = snow_particleCount;
		while (pCount--) {
            var particle = snow_points[pCount];
            if (particle.y < -50) {
                particle.y = 100;
                particle.velocity.y = 0.51;
            }
            particle.velocity.y -= Math.random() * .02;
            particle.y += particle.velocity.y;
		}
		snow_geometry.verticesNeedUpdate = true;
		snow_particleSystem.rotation.y += 0.009;
		snow_geometry.setFromPoints(snow_points)

        //snow_geometry.computeVertexNormals() 

  } 

});


